module.exports = __webpack_public_path__ + "static/media/huli_428.9fad4991.gif";